<template>
    <v-container fluid fill-height class="grey lighten-4">

        <MessageOverlay ref="overlay" @end="activateLogin"/>
        <RequestNewPassword :display="displayRequestNewPassword" @cancel="cancelRequestNewPasswordDialod"  @valid="validRequestNewPasswordDialod" />
        <NewPassword :display="displayNewPassword" :emailProp="emailToChangePass" @cancel="cancelNewPasswordDialod" @valid="validNewPasswordDialod" />
        <SignIn :display="displaySignIn" @cancel="displaySignIn=false" @valid="validSignInDialod" />

        <v-row align="center" justify="center">
            <v-col cols="auto">
                <v-img src="@/assets/logo.png" width="150"></v-img>
            </v-col>
            <v-col cols="auto">
                <h1>UTC Supervision</h1>
            </v-col>
            <v-col cols="12">
                <v-card max-width="500" class="mx-auto rounded-lg" elevation="12">
                    <v-card-text>
                        <v-form ref="form" @submit.prevent="submit()">
                            <v-text-field
                                v-model="form.email"
                                :rules="emailRules"
                                prepend-icon="mdi-account-circle"
                                name="email"
                                label="E-mail"
                                type="text"
                                outlined
                                required
                                :disabled="!activated"
                                @input="showError = false"
                            ></v-text-field>
                            <v-text-field
                                v-model="form.password"
                                :rules="passwordRules"
                                id="password"
                                prepend-icon="mdi-lock"
                                name="password"
                                label="Password"
                                :type="showPassword ? 'text' : 'password'"
                                outlined
                                required
                                :disabled="!activated"
                                :append-icon="passwordFocused ? showPassword ? 'mdi-eye-off' : 'mdi-eye' : undefined"
                                @click:append="showPassword = !showPassword"
                                @focus="passwordFocused = true"
                                @blur="passwordFocused = false"
                                @input="showError = false"
                            ></v-text-field>
                            <v-btn 
                                type="submit" 
                                block class="gradient-wintech rounded-lg" 
                                :loading="buttonLoading"
                                :disabled="!activated"
                            >Login</v-btn>
                            <!-- <v-row justify="space-between"> //MULTIORGA
                                <v-btn class="mt-5" text color="blue" @click="displaySignIn=true" >Sign in</v-btn>
                                <v-btn class="mt-5" text color="blue" @click="openRequestNewPasswordDialog" >Password forgotten</v-btn>
                            </v-row> -->
                            <v-row justify="end"> 
                                <v-btn class="mt-5" text color="blue" @click="openRequestNewPasswordDialog" >Password forgotten</v-btn>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import axios from 'axios';
import { mapGetters, mapActions } from "vuex";
import { sha3_512 } from 'js-sha3';
import NewPassword from './Confidentiality/NewPassword.vue';
import RequestNewPassword from './Confidentiality/RequestNewPassword.vue';
import SignIn from './Confidentiality/SignIn.vue';
import MessageOverlay from './Overlay/MessageOverlay.vue';

export default {
    name: "Login",
    components: {NewPassword,RequestNewPassword,MessageOverlay, SignIn},
    data() {
        return {
            emailToChangePass: "",

            form: {
                email: "",
                password: "",
            },
            emailRules: [
                v => !!v || 'Email is required'
            ],
            passwordRules: [
                v => !!v || 'Password is required'
            ],
            showPassword: false,
            passwordFocused: false,
            showError: false,
            buttonLoading: false,
            displayNewPassword: false,
            displayRequestNewPassword: false,
            displaySignIn: false,
            activated: true,
        };
    },
    async mounted() {
        try {
            const res = await axios.get('login', { params: this.$route.query });
            if(res.status == 200){
                this.emailToChangePass = res.data;
                this.openNewPasswordDialog();
            }
        } catch (error) {
            console.error(error);
        }
    },
    computed: {
        ...mapGetters({ user: "StateUser" }),
    },
    methods: {
        ...mapActions(["LogIn"]),
        async submit() {
            this.deactivateLogin();
            this.buttonLoading = true;
            if (this.$refs.form.validate()) {
                try {
                    await this.LogIn({
                        email: this.form.email,
                        password: sha3_512(this.form.password)
                    });
                    if(!this.user.orga)
                        this.$router.push("/account");
                    else
                        this.$router.push("/dashboard");
                    this.showError = false;
                } catch (error) {
                    if(error.response.status == 401){
                        this.$refs.overlay.showOverlay("error", this.$vuetify.lang.t('$vuetify.login.loginError'))
                    } else if(error.response.status == 403){
                        this.$refs.overlay.showOverlay("error", this.$vuetify.lang.t('$vuetify.login.noOrganization'), 7000)
                    }
                    this.showError = true;
                }
            }
            this.buttonLoading = false;
        },
        
        
        openRequestNewPasswordDialog(){
            this.displayRequestNewPassword=true;
        },
        cancelRequestNewPasswordDialod(){
            this.displayRequestNewPassword=false;
        },
        validRequestNewPasswordDialod(){
            this.displayRequestNewPassword=false;
            this.$refs.overlay.showOverlay("success", this.$vuetify.lang.t('$vuetify.login.passwordResetSendOK'), 5000);
        },

        

        openNewPasswordDialog(){
            this.displayNewPassword=true;
        },
        cancelNewPasswordDialod(){
            this.displayNewPassword=false;
        },
        validNewPasswordDialod(){
            this.displayNewPassword=false;
            this.$refs.overlay.showOverlay("success",  this.$vuetify.lang.t('$vuetify.login.passwordUpdated'));
        },
        validSignInDialod(){
            this.displaySignIn=false;
        },
        deactivateLogin(){
            this.activated=false;
        },
        activateLogin(){
            this.activated=true;       
        }
    },
};
</script>